import { z } from "zod";

import i18n from "@/i18n";

const newsSchema = z
  .object({
    title: z.string().min(1, { message: i18n.t("validation.newsTitleRequired") }).trim(),
    excerpt: z
      .string()
      .min(1, { message: i18n.t("validation.newsExcerptRequired") })
      .trim(),
    data: z.string().min(1, { message: i18n.t("validation.newsContentRequired") }).trim(),
    sendLater: z.boolean().optional(),
    notificationDate: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.sendLater) {
      if (!data.notificationDate) {
        ctx.addIssue({
          path: ["notificationDate"],
          code: z.ZodIssueCode.custom,
          message: i18n.t("validation.futureScheduleOnly"),
        });
      } else if (new Date(data.notificationDate) <= new Date()) {
        ctx.addIssue({
          path: ["notificationDate"],
          code: z.ZodIssueCode.custom,
          message: i18n.t("validation.futureScheduleOnly"),
        });
      }
    }
  });

type NewsSchemaFormData = z.infer<typeof newsSchema>;

export { newsSchema };
export type { NewsSchemaFormData };
